export default "__VITE_ASSET__oI_pHeo5__"